import { useEffect, type RefObject } from "react";

type ClickOutsideEventType = "mousedown" | "pointerdown";

export default function useClickOutside(
	refs: RefObject<Element | null>[],
	callback: () => void,
	eventType: ClickOutsideEventType = "mousedown"
): void {
	useEffect(() => {
		function handleClickOutside(event: Event): void {
			const target = event.target;
			if (!(target instanceof Node)) {
				callback();
				return;
			}
			for (const ref of refs) {
				if (ref.current?.contains(target)) {
					return;
				}
			}
			callback();
		}
		document.addEventListener(eventType, handleClickOutside, { capture: true });
		return () => {
			document.removeEventListener(eventType, handleClickOutside, { capture: true });
		};
	}, [refs, callback, eventType]);
}
